"use client";

import { useEffect, useRef, useState } from "react";

import { CcCustomCalBooking } from "@/components/booking/CcCustomCalBooking";
import type { BookCallFormCopyOverrides } from "@/lib/book-call-popup-copy";
import type { Lang } from "@/lib/types";

import { trackAiKollenEvent } from "./ai-kollen-track";

type CcAkBookingProps = {
  lang: Lang;
  formCopy?: BookCallFormCopyOverrides;
};

/**
 * The booking calendar embedded right on the page (GHL, same as the site popup).
 * It mounts (and fetches a month of slots) only when the section comes near the
 * screen, so it doesn't weigh on the first load.
 */
export function CcAkBooking({ lang, formCopy }: CcAkBookingProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [near, setNear] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || near) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setNear(true);
      },
      { rootMargin: "800px 0px" },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [near]);

  return (
    <div ref={ref} className="cc-ak-booking__widget" data-pending={near ? undefined : "true"}>
      {near ? (
        <CcCustomCalBooking
          lang={lang}
          bookingVariant="ai-kollen"
          formCopyOverrides={formCopy}
          onBooked={() => trackAiKollenEvent("ai_kollen_booked")}
        />
      ) : null}
    </div>
  );
}
